import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=8e9b572e&scoped=true"
import script from "./qa.vue?vue&type=script&lang=js"
export * from "./qa.vue?vue&type=script&lang=js"
import style0 from "./qa.vue?vue&type=style&index=0&id=8e9b572e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9b572e",
  null
  
)

export default component.exports